var React = require('react');

function ContactPhoneInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z","stroke":"#0A9E50","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9","stroke":"#0A9E50","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ContactPhoneInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ContactPhoneInline;

ContactPhoneInline.default = ContactPhoneInline;
